import React from 'react';

interface ScrollContainerProps {
  children: React.ReactNode;
  className?: string;
  maxHeight?: string;
}

export function ScrollContainer({ 
  children, 
  className = '', 
  maxHeight = '400px'
}: ScrollContainerProps) {
  return (
    <div
      className={`overflow-y-auto ${className}`}
      style={{
        maxHeight,
        msOverflowStyle: 'none',
      }}
    >
      {children}
    </div>
  );
}
